<h1>Verzeichnisse erstellen vs. Menü erstellen</h1>
<section class="article">
  <article>
    <div class="text">
      <p>
        Nach der Eingabe der Basisdaten für ein Projekt (Title, Sprachen usw.)
        muss die Menüstruktur erstellt werden. Das kann manuell erfolgen (Menü
        erstellen) oder initial aus einer Verzeichnisstruktur eingelesen werden
        (Verzeichnis importieren). Welches ist jetzt die bessere Methode?
      </p>
      <p>
        Geht man bei der Erstellung einer Video-Anleitung so vor, dass man
        zuerst alle Video-Clips dreht und danach die Video-Anleitung mit
        video2manual erstellt, empfiehlt es sich, die Clips in einer
        Verzeichnisstruktur zu organisieren. Dabei wird eine Verzeichnisstruktur
        aufgebaut, die dem späteren Menü entspricht. In einem Hauptverzeichnis
        wird dazu für jeden Menüpunkt ein Unterverzeichnis mit dem Namen des
        Menüpunktes erstellt. In diesen Verzeichnissen werden wiederum
        Unterverzeichnisse für jede Sequenz angelegt. In den Unterverzeichnissen
        liegen dann die einzelnen Clips.
      </p>
      <p>
        Beim Einlesen des Verzeichnisses wird aus den Verzeichnissen das Menü
        aufgebaut und alle Clips eingelesen und zugeordnet. Danach ist eine
        initiale Projektstruktur schon angelegt, die in video2manual
        weiterbearbeitet werden kann.
      </p>
      <p>
        Ein kleiner Nachteil ergibt sich aus der Sortierung der Verzeichnisse im
        Betriebssystem. Die Verzeichnisse (und dadurch auch die Menüs und
        Sequenzen) werden alphabetisch sortiert. Man kann die Struktur nach dem
        Import in video2manual umsortieren oder die Verzeichnisse vorher
        entsprechend benennen (z.B. indem man eine Zahl vor den Namen stellt -
        01_Menü) und sie dann ev. in video2manual nachträglich umbenennt.
      </p>
      <p>
        Erstellt man eine Video-Anleitung schrittweise, indem man z.B. erst
        einen Teil filmt, dann bearbeitet, dann einen nächsten Teil filmt und
        bearbeitet usw. ist die Methode der manuellen Erstellung des Menüs
        angebracht. Hierbei baut man sich die Menüstruktur in video2manual
        schrittweise auf und fügt die passenden Clips ein. Dabei können die
        Clips von beliebigen Datenquellen (Festplatte, Netzwerk, SD-Karte ...)
        kommen.
      </p>
      <img class="screenshot" src="assets/new_project.jpg" />
    </div>
    <a [routerLink]="['/blog']" class="call">Zurück zur Übersicht</a>
  </article>
</section>
